export function mapTree<TNode extends Object>(tree: TNode[], childrenExpr: string, mapFn: (node: TNode) => TNode): TNode[] {
	const traverse = (node: TNode) => {
		if (Array.isArray(node[childrenExpr])) {
			node[childrenExpr] = node[childrenExpr].map(traverse);
		}

		return mapFn(node);
	};

	return tree.map(traverse);
}
